import React from "react";
import { Icon } from "semantic-ui-react";

export default ({ botInstance }) =>
  botInstance.tickError && (
    <Icon name="warning circle" color="red" title={`Tick error: ${botInstance.tickError.split("\n")[0]}`} />
  );



// WEBPACK FOOTER //
// ./src/bot/ErrorIcon.js